import "@/App.css";
import "@/themes.css";
import "@/lib/theme"; // Side-effect: applies stored theme on load
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Customers from "@/pages/Customers";
import Products from "@/pages/Products";
import Reports from "@/pages/Reports";
import Backup from "@/pages/Backup";
import Settings from "@/pages/Settings";
import Layout from "@/components/layout/Layout";
import { NumpadProvider } from "@/lib/numpad-context";
import { AuthProvider, useAuth } from "@/lib/auth-context";
import { SuccessOverlayProvider } from "@/lib/success-overlay";

function ProtectedRoute({ children, requireSecurity = false }) {
    const { user, loading, canAccessSecurity } = useAuth();
    if (loading)
        return (
            <div className="flex items-center justify-center min-h-screen bg-white">
                <div className="text-sm font-medium uppercase tracking-[0.2em] text-[#5C5F66]">
                    Φορτωση...
                </div>
            </div>
        );
    if (!user) return <Navigate to="/login" replace />;
    if (requireSecurity && !canAccessSecurity)
        return <Navigate to="/sale" replace />;
    return <Layout>{children}</Layout>;
}

function App() {
    return (
        <div className="App font-body">
            <BrowserRouter>
                <AuthProvider>
                    <NumpadProvider>
                        <SuccessOverlayProvider>
                        <Routes>
                            <Route path="/login" element={<Login />} />
                            <Route
                                path="/"
                                element={
                                    <ProtectedRoute>
                                        <Dashboard />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/sale"
                                element={
                                    <ProtectedRoute>
                                        <Dashboard />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/dashboard"
                                element={
                                    <ProtectedRoute>
                                        <Dashboard />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/customers"
                                element={
                                    <ProtectedRoute>
                                        <Customers />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/products"
                                element={
                                    <ProtectedRoute>
                                        <Products />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/reports"
                                element={
                                    <ProtectedRoute>
                                        <Reports />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/backup"
                                element={
                                    <ProtectedRoute requireSecurity>
                                        <Backup />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/settings"
                                element={
                                    <ProtectedRoute>
                                        <Settings />
                                    </ProtectedRoute>
                                }
                            />
                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                        </SuccessOverlayProvider>
                    </NumpadProvider>
                </AuthProvider>
            </BrowserRouter>
            <Toaster
                position="top-right"
                toastOptions={{
                    style: {
                        borderRadius: 0,
                        border: "1px solid #0A0A0A",
                        fontFamily: "IBM Plex Sans, sans-serif",
                    },
                }}
            />
        </div>
    );
}

export default App;
